const residentPostalPageData = {
  slug: "resident-postal",
  title: "RESIDENT Postal",
  introduction:
    "Our RESIDENT Postal database is a powerful and accurate file with over 98% coverage of all households in the UK.",
  hero: {
    eyebrow: "Direct Mail & Postal Data",
    align: "left",
    highlights: [
      { value: "98%", label: "UK household coverage" },
    ],
    cta: { label: "Enquire now", href: "#enquiry" },
  },

  sections: [
    {
      id: "what-is-resident-postal",
      variant: "feature",
      icon: "location",
      title: "What is RESIDENT Postal?",
      content: [
        "We provide contact names and postal addresses to help businesses find new people who may be interested in their products or services. We can also use our segmentations and models to help clients choose the most relevant people for them to talk to.",
      ],
    },
    {
      id: "accurate-data",
      title: "Accurate Data for Better Direct Mail",
      titleDivider: true,
      content: [
        "The best direct mail campaigns start with accurate data, which can save you money by reducing wasted mailings being incorrectly addressed to the individual and, or the household postal address.",
        "We identify issues like mailing preferences, incomplete addresses, gone-aways or deceased records, and use advanced tools to correct them. This reduces print, fulfilment, and postage costs, and maximises your return on investment.",
      ],
    },
    {
      id: "personalisation",
      title: "Personalisation That Engages",
      titleDivider: true,
      content: [
        "Personalised direct mail campaigns significantly boost audience engagement and conversions. So getting the personalisation correct delivers measurably better results.",
      ],
    },
    {
      id: "grow-your-database",
      title: "Grow and Maintain Your Mailing Database",
      titleDivider: true,
      content: [
        "We can help you update your customer mailing database as well as provide you with access to other UK consumer prospects that meet your acquisition strategies.",
      ],
    },
    {
      id: "regular-cleaning",
      title: "Regular Cleaning",
      titleDivider: true,
      content: [
        "Our RESIDENT Postal database is fully refreshed every month, ensuring you have access to new and updated data. We also conduct regular checks against the Mailing Preference Service to maintain the highest quality data.",
      ],
    },
    {
      id: "design-and-print",
      title: "Need Help with Design and Print?",
      titleDivider: true,
      content: [
        "We can help you to create and optimise your creative assets to ensure maximum impact. We also provide print management to meet your needs.",
      ],
    },

    {
      id: "at-a-glance",
      title: "RESIDENT Postal at a Glance",
      titleDivider: true,
    },
    {
      type: "stats",
      variant: "cards",
      items: [
        { value: "98", suffix: "%", label: "UK household coverage" },
        { value: "29", suffix: "M", label: "UK households" },
        { value: "2.4", label: "Average people per household" },
      ],
    },

    {
      type: "benefits",
      variant: "checklist",
      heading: "Key Features & Benefits",
      items: [
        {
          title:
            "Access a vast audience with millions of verified UK consumer addresses.",
        },
        { title: "Powered by trusted and compliant sources" },
        {
          title:
            "Filter by key variables such as age, property type, length of residency, marital status, affluence, and many more to create targeted lists.",
        },
        {
          title:
            "Enjoy flexible, affordable pricing with no minimum order, and take advantage of our full end-to-end print and post solution",
        },
      ],
    },

    {
      id: "cta-highlight",
      variant: "feature",
      icon: "mail",
      title: "Get Started",
      cta: { label: "Enquire now", href: "#enquiry" },
    },
  ],

  // No fixed pricing model exists for this service.
  pricing: null,

  enquiryForm: {
    enabled: true,
    serviceName: "RESIDENT Postal",
    anchorId: "enquiry",
    heading: "Enquire now",
  },

  seo: {
    title: "RESIDENT Postal - Lloyd James Data Consultancy",
    description:
      "RESIDENT Postal covers 98% of UK households — accurate, regularly refreshed address data for higher-performing, lower-waste direct mail campaigns.",
    keywords:
      "RESIDENT postal, postal data, direct mail data, UK household coverage, address data, mailing list, Mailing Preference Service, Lloyd James",
    canonical: "/resident-postal/",
  },
};

export default residentPostalPageData;
